/** D1 `CURRENT_TIMESTAMP` values are UTC without a zone, e.g. `2026-10-31 21:05:00`. */
export function parseServerTime(value: string): Date {
  const iso = value.includes('T') ? value : value.trim().replace(' ', 'T');
  return new Date(/Z|[+-]\d\d:?\d\d$/.test(iso) ? iso : `${iso}Z`);
}

/** When a scheduled task releases: its offset after the game first went live. */
export function releaseTime(
  startedAt: string | null | undefined,
  minutes: number | null | undefined,
) {
  if (!startedAt) return null;
  return new Date(parseServerTime(startedAt).getTime() + (minutes ?? 0) * 60_000);
}

const clock = (date: Date) => date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });

/** Admin label for a scheduled task, e.g. "Releases 10:30 PM" or "Released 9:40 PM". */
export function releaseLabel(
  task: { scheduledOffsetMinutes?: number | null; revealedAt?: string | null },
  startedAt: string | null | undefined,
  now = new Date(),
) {
  if (task.revealedAt) return `Released ${clock(parseServerTime(task.revealedAt))}`;
  const at = releaseTime(startedAt, task.scheduledOffsetMinutes);
  if (!at) return `Releases ${task.scheduledOffsetMinutes ?? 0} min after start`;
  const minutesLeft = Math.ceil((at.getTime() - now.getTime()) / 60_000);
  return minutesLeft > 0 ? `Releases ${clock(at)} (in ${minutesLeft} min)` : 'Releasing now';
}
